import React from "react";
import { Fade } from "react-awesome-reveal";
import { useMediaQuery } from "react-responsive";
import "../styles/PorqueElegirnos.scss";
import id1 from "../images/identificadores/1.svg";
import id2 from "../images/identificadores/2.svg";
import id3 from "../images/identificadores/3.svg";
import id4 from "../images/identificadores/4.svg";
import id5 from "../images/identificadores/5.svg";

const PorqueElegirnos = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 480px)" });
  let velFade = 2000;

  const tarjetas = [
    {
        id: 1,
        imagen: id1,
        titulo: 'Experiencia y Maestría',
        texto: 'Con años de experiencia, perfeccionamos nuestros servicios para impulsar tu presencia online. Nuestro equipo garantiza resultados dedicados a proporcionarte soluciones integrales para tu éxito digital.',
    },
    {
        id: 2,
        imagen: id2,
        titulo: 'Calidad Garantizada',
        texto: 'Utilizamos las mejores estrategias y las últimas tecnologías para asegurar resultados. Ofrecemos una garantía en todos nuestros servicios, asegurando tu tranquilidad.',
    },
    {
        id: 3,
        imagen: id3,
        titulo: 'Atención al Detalle',
        texto: 'Cada estrategia digital es única y merece un enfoque personalizado. Adaptamos nuestros servicios a tus necesidades y objetivos específicos, siempre asegurando que cada detalle se maneje con precisión.',
    },
    {
        id: 4,
        imagen: id4,
        titulo: 'Servicio Integral',
        texto: 'Más que un proveedor, somos tu socio en cada proyecto digital. Ofrecemos un servicio integral que abarca desde la creación de contenido hasta el desarrollo de landing pages y campañas de tráfico.',
    },
    {
        id: 5,
        imagen: id5,
        titulo: 'Compromiso con el Cliente',
        texto: 'Nuestra prioridad es tu éxito. Nos esforzamos por ofrecerte un servicio excepcional, adaptado a tus necesidades y objetivos. Tu satisfacción y confianza son nuestra mayor recompensa.',
    },
  ];

  return (
    <section className="text-center" id="porqueE">
      <center>
        <Fade>
          <br/><h4 className="mt-5 fw-bold fs-3" id="titlePorque">
            ¿Por qué elegirnos?
          </h4>
        </Fade>
      </center>
      <div className="containerCards">
            {tarjetas.map((tarjeta) => (
                <div key={tarjeta.id} className="containerCard text-center">
                    {isMobile && (
                        <Fade duration={velFade}>
                            <img className="imgCard" src={tarjeta.imagen} alt={tarjeta.titulo} />
                            <div className="containerCardText">
                                <p className="firstText fw-bold">{tarjeta.titulo}</p>
                                <p className="textIdentificador">{tarjeta.texto}</p>
                            </div>
                        </Fade>
                    )}
                    {!isMobile && (
                        <div>
                            <img className="imgCard" src={tarjeta.imagen} alt={tarjeta.titulo} />
                            <div className="containerCardText">
                                <p className="firstText fw-bold">{tarjeta.titulo}</p>
                                <p className="textIdentificador">{tarjeta.texto}</p>
                            </div>
                        </div>
                    )}
                </div>
            ))}
      </div>
      <br/><br/><br/>
    </section>
  );
};

export default PorqueElegirnos;
